import React, { useState } from 'react';
import { Stack, Group, Title, Text, TextInput, Button, Code, ScrollArea, Loader, Badge } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import useAuthenticatedData from '../../../hooks/useAuthenticatedData';
import config from '../../../config';
import DraftBadge from '../../common/DraftBadge';

export default function RotabullCompanyLookup() {
  const [term, setTerm] = useState('');
  const [query, setQuery] = useState(null);   // the submitted search

  const url = query
    ? `${config.apiBaseUrl}/api/funnel/rotabull-companies?search=${encodeURIComponent(query)}`
    : null;
  const { data, isLoading, error } = useAuthenticatedData(url);

  const run = () => { if (term.trim()) setQuery(term.trim()); };

  return (
    <Stack gap="md" p="md">
      <DraftBadge />
      <div>
        <Title order={2}>Rotabull Company Lookup</Title>
        <Text size="sm" c="dimmed">Search the Rotabull company master and see the raw details for a company (e.g. your test company).</Text>
      </div>

      <Group>
        <TextInput
          w={360} placeholder="Company name, code, or ERP key…"
          value={term} onChange={(e) => setTerm(e.currentTarget.value)}
          onKeyDown={(e) => e.key === 'Enter' && run()}
        />
        <Button leftSection={<IconSearch size={16} />} loading={isLoading} onClick={run} disabled={!term.trim()}>
          Search
        </Button>
      </Group>

      {isLoading && <Group gap="xs"><Loader size="sm" /><Text size="sm" c="dimmed">Paging the Rotabull company master…</Text></Group>}
      {error && <Text c="red">Lookup failed. Is the API up and Rotabull auth configured?</Text>}

      {data && !isLoading && (
        <Stack gap="xs">
          <Group gap="xs">
            <Badge variant="light">{data.matchCount} match{data.matchCount === 1 ? '' : 'es'}</Badge>
            <Text size="xs" c="dimmed">scanned {data.companiesScanned} companies across {data.pagesScanned} page(s)</Text>
          </Group>
          <ScrollArea.Autosize mah={620}>
            <Code block style={{ fontSize: 12 }}>
              {JSON.stringify(data.matches ?? [], null, 2)}
            </Code>
          </ScrollArea.Autosize>
        </Stack>
      )}
    </Stack>
  );
}
